import React from 'react'
import { ResultBorrowingComponent } from '../../components/borrowSystem/ResultBorrowingComponent'
import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { Footer } from "../../components/share/Footer";
export const ResultBorrowingContainer = () => {
    const titleName = "คําขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
    return (
        <div className="page-container bg-landing">
            <NavbarBorrowSystem />
            <HeadTitle title={titleName} />
            <ResultBorrowingComponent />
            <Footer />
        </div>
    );
}
